import {EntriesType} from "@/types/Entries.type";

/**
 * this is equivalent of Object.entries() just with typecasting
 */
export default function entries<T>(object: T) {
    return Object.entries(object) as EntriesType<typeof object>
}